import abi from './Transactions.json';

export const contractABI = abi.abi;

export const contractAddress = "0x3027656Db79cC2D4dbeD42dACBC47567e15b4254";